// extracted by mini-css-extract-plugin
export default {"formWrapper":"auth_formWrapper__uQhLX","header":"auth_header__JA9d6","formData":"auth_formData__gnjhS","signupBtn":"auth_signupBtn__S7IIW","loginConfirm":"auth_loginConfirm__rGLw3"};